import { useState, useEffect } from 'react';
import { calculateAnnualSavings, calculatePaybackMonths } from '../../utils/conversionResults/calculations';
import { testimonials } from '../../data/conversionResults/testimonials';

export const useConversionResults = ({ energyBaseline, potentialSavings = 0 }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [showUrgency, setShowUrgency] = useState(false);

  useEffect(() => {
    // Rotate testimonials every 5 seconds
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    // Show urgency message after 30 seconds
    const urgencyTimer = setTimeout(() => {
      setShowUrgency(true);
    }, 30000);

    return () => {
      clearInterval(interval);
      clearTimeout(urgencyTimer);
    };
  }, []);

  const { conservative, aggressive } = calculateAnnualSavings(energyBaseline || {}, potentialSavings);
  const paybackMonths = calculatePaybackMonths(conservative);

  return {
    testimonials,
    currentTestimonial,
    setCurrentTestimonial,
    showUrgency,
    conservative,
    aggressive,
    paybackMonths
  };
};


